import { pathAsModuleName } from 'src/helpers/string'

const moduleContext = require.context('.', true, /index\.js$/)

/**
 * load all files (module) in this folder recursively.
 * And exports them as a keyed object
 * the key is the cleaned filename and the value si the default export
 */
export default moduleContext
  .keys()
  .filter(fileName => fileName !== './index.js')
  .reduce((result, fileName) => ({
    ...result,
    [pathAsModuleName(fileName)]: moduleContext(fileName).default || moduleContext(fileName)
  }), {})
